var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdministrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2449_6677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368 309C371 308 374 310 375 313C376 316 374 319 371 320C362 323 353 325 343 326C334 327 324 328 314 328C303 328 293 327 283 326C273 325 263 322 254 320C251 319 249 315 250 312C251 309 254 307 258 308C266 311 275 313 285 314C294 315 304 316 314 316C323 316 333 316 341 314C351 313 360 311 368 309Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424 103.999C427 123.999 424 145.999 410 170.999C408 173.999 409 176.999 411 178.999C449 215.999 404 233.999 404 234.999C402 234.999 401 236.999 401 238.999C398 253.999 394 264.999 389 273.999C383 286.999 376 293.999 372 297.999C370 299.999 368 301.999 367 304.999C365 306.999 364 309.999 364 312.999C363 315.999 365 318.999 368 319.999C371 320.999 375 318.999 375 315.999C376 313.999 377 311.999 377 309.999C378 308.999 379 307.999 380 306.999C385 302.999 393 293.999 400 278.999C405 269.999 409 258.999 412 243.999C423 237.999 462 214.999 422 172.999C460 100.999 421 48.9993 372 21.9993C356 12.9993 339 6.99926 324 3.99926C308 -0.000744581 293 -0.000744581 282 1.99926C268 4.99926 259 12.9993 259 24.9993C142 37.9993 192 150.999 203 172.999C163 214.999 202 237.999 214 243.999C217 257.999 221 269.999 225 278.999C232 292.999 240 301.999 246 306.999C246 307.999 247 308.999 248 309.999C249 311.999 249 312.999 250 314.999C251 318.999 254 320.999 257 319.999C261 318.999 262 315.999 262 311.999C261 309.999 260 306.999 258 303.999C257 301.999 255 299.999 254 297.999C249 293.999 242 285.999 236 273.999C232 264.999 228 253.999 225 238.999C224 236.999 223 234.999 221 234.999C220 233.999 176 214.999 215 178.999C216 177.999 216 176.999 216 175.999V174.999H217V173.999C217 173.999 217 172.999 216 172.999C216 168.999 206 110.999 255 83.9993C276 129.999 321 115.999 362 103.999C390 94.9993 416 87.9993 424 103.999Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369 316C353 320 331 322 314 322C295 322 273 320 257 316C256 317 255 318 254 319C254 322 254 324 254 327C253 332 251 336 248 338C243 342 238 345 234 347C280 356 345 356 391 348C388 346 384 343 380 340L377 338C374 336 373 332 372 327C372 325 372 322 372 320C370 319 369 318 369 316ZM313 360C298 360 284 359 271 358L313 402L354 358C341 359 327 360 313 360Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308 406L262 357C251 356 240 354 231 352C225 355 219 357 210 360L203 363L243 460L271 437V436L308 406Z",
    fill: "#0F6CA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239 466L198 365H197C119 394 118 437 118 440V441V505H288L283 457L273 443L244 467L243 468C241 468 240 468 239 466Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313 410L277 439L287 452H313H338L348 439L313 410Z",
    fill: "#0F6CA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313 458H289L294 505H331L336 458H313Z",
    fill: "#0F6CA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317 406L354 436V437L382 460L422 363L416 361C405 357 399 355 394 352C385 354 374 356 363 357L317 406Z",
    fill: "#0F6CA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428 365L387 466C386 468 384 468 383 468C382 468 382 467 382 467L353 443L342 457L337 505H508V441C508 441 510 395 428 365Z",
    fill: "#474748"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 207C125 209 129 211 133 213C136 215 140 217 143 220L161 210C164 208 168 209 169 212L190 247C191 250 190 253 187 255L169 265C170 267 170 268 170 269C170 272 170 275 170 278C170 281 170 284 170 287C170 288 170 289 169 291L187 301C190 303 191 306 190 309L169 344C168 347 164 348 161 346L143 336C140 339 136 341 133 343C129 345 125 347 121 349V369C121 373 119 375 115 375H75.0005C72.0005 375 69.0005 373 69.0005 369V349C65.0005 347 61.0005 345 58.0005 343C54.0005 341 50.0005 339 47.0005 336L29.0005 346C26.0005 348 23.0005 347 21.0005 344L1.00048 309C-0.999521 307 0.000479221 303 3.00048 301L21.0005 291C21.0005 289 21.0005 288 20.0005 287C20.0005 284 20.0005 281 20.0005 278C20.0005 275 20.0005 272 20.0005 269C21.0005 268 21.0005 267 21.0005 265L3.00048 255C0.000479221 253 -0.999521 250 1.00048 247L21.0005 212C23.0005 209 26.0005 208 29.0005 210L47.0005 220C50.0005 217 54.0005 215 58.0005 213C61.0005 211 65.0005 209 69.0005 207V187C69.0005 183 72.0005 181 75.0005 181H115C119 181 121 183 121 187V207ZM119 254C113 248 104 244 95.0005 244C86.0005 244 77.0005 248 71.0005 254C65.0005 260 61.0005 269 61.0005 278C61.0005 287 65.0005 296 71.0005 302C77.0005 308 86.0005 312 95.0005 312C104 312 113 308 119 302C125 296 129 287 129 278C129 269 125 260 119 254Z",
    fill: "#0F6CA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2449_6677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrator);
export default __webpack_public_path__ + "static/media/Administrator.da18902fc6f0600706a6b28bda29d2e5.svg";
export { ForwardRef as ReactComponent };